<template>
    <div class="box">
        <Header></Header>

        <section>
            <img style="width: 100%;height: 150px;" :src="banner.path" alt="">
            <div class="nav" style="padding: 0 10px;margin-top: 10px;">
                <p style="border-left: 3px solid #BB1E10;padding-left: 10px;font-size: 17px;color: #333333;font-weight: bold;">境外物流</p>
                <p style="font-size: 14px;color:#909090;padding-top: 20px;">{{text}}</p>
                <img style="width: 100%;height: auto;margin-top: 20px;" :src="path" alt="">
            </div>

            <Footer></Footer>
        </section>
    </div>
</template>

<script>
import axios from 'axios';
import Header from '../Header';
import Footer from '../Footer';

export default {
	name: 'Overseas',
	components: {
		Header,
        Footer
	},
	data () {
		return {
            banner: {},
            text: '',
            path: ''
		}
	},

	mounted() {
        this.getData();
        this.getList();
	},

	methods: {
        // 获取轮播图
		getData() {
			axios({
				url: this.url + '/content/input/fileList',
				method: 'post',
				data: {
					parentId: 0,
                    type: 13
				},
			}).then( res => {
                this.banner = res.data[0][0];
			});
		},

        // 获取轮播图
		getList() {
			axios({
				url: this.url + '/content/introduce/list?type=1',
				method: 'get',
				data: {
				},
			}).then( res => {
                this.text = res.data.rows[0].text;
                this.path = res.data.rows[1].path;
			});
		}
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

html, body {
    margin: 0;
    padding: 0;
    overflow-x: hidden;
}
p, span, ul, li{
    margin: 0;
    padding: 0;
}
.box {
    display: flex;
    flex-direction: column;
    height: 100vh;
    overflow: hidden;
}

section {
    flex: 1;
    overflow-y: scroll;
}

</style>



// WEBPACK FOOTER //
// src/components/ProjectIntroduction/overseasLogistics.vue